import React, { memo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { setFilterMenuStatus, setSpecialFilterDataArray, setSpecialFilterId } from '../actions';
import { loadCourses } from '../../App/actions';
import CollapsedList from '../../../utils/Components/CollapsedList';
import FilterCollapse from './FilterCollapse';
import FilterOverlayBlock from '../../../utils/Components/FilterOverlayBlock';
import { FilterHeaderBlock } from '../FilterOverlay/FilterHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import LocalReset from '../../../utils/Components/LocalReset';
import CurrentFilterResetBlock from '../../../components/CurrentFilterResetBlock';
import { useInjectReducer } from '../../../utils/injectReducer';
import reducer from './reducer';
import { initialState } from '../reducer';
import { makeSelectSpecialFilterMenuStatus } from './selectors';
import { toggleSpecialFilterMenu } from './actions';
import Items from './Items';
import ShowResultsButton from '../../../utils/Components/ShowResultsButton';
import FilterListWrapper from '../../../utils/Components/FilterListWrapper';

const key = 'special';

export function SearchSpecial({
  specialFilterMenuStatus,
  onToggleSpecialFilterMenu,
  onSetSpecialFilterDataArray,
  onSetSpecialFilterId,
  onSetFilterMenuStatus,
}) {
  useInjectReducer({ key, reducer });

  const resetFilter = () => {
    onSetSpecialFilterId(initialState.specialFilterId);
    onSetSpecialFilterDataArray(initialState.specialFilterDataArray);
  };

  const handleResultsClick = () => {
    onToggleSpecialFilterMenu(false);
    onSetFilterMenuStatus(false);
  };

  const CurrentFilterReset = () => (
    <LocalReset onClick={() => resetFilter()}>
      <CurrentFilterResetBlock />
    </LocalReset>
  );

  /**
   * Main return function.
   */
  return (
    <CollapsedList className={specialFilterMenuStatus ? 'open' : ''}>
      <FilterCollapse />
      <FilterOverlayBlock className={'item-list'}>
        <FilterHeaderBlock>
          <span>Durchführung</span>
          <FontAwesomeIcon icon={faArrowLeft} onClick={() => onToggleSpecialFilterMenu(false)} />
        </FilterHeaderBlock>
        <CurrentFilterReset />
        <FilterListWrapper>
          <Items />
        </FilterListWrapper>
        <ShowResultsButton onClick={() => handleResultsClick()}>Resultate anzeigen</ShowResultsButton>
      </FilterOverlayBlock>
    </CollapsedList>
  );
}

SearchSpecial.propTypes = {
  specialFilterMenuStatus: PropTypes.bool,
  onToggleSpecialFilterMenu: PropTypes.func,
  onSetSpecialFilterDataArray: PropTypes.func,
  onSetSpecialFilterId: PropTypes.func,
  onSetFilterMenuStatus: PropTypes.func,
};

// SearchSpecial.defaultProps = {
//   specialFilterMenuStatus: false,
//   onToggleSpecialFilterMenu: () => {},
//   onSetSpecialFilterDataArray: () => {},
//   onSetSpecialFilterId: () => {},
//   onSetFilterMenuStatus: () => {},
// };

const mapStateToProps = createStructuredSelector({
  specialFilterMenuStatus: makeSelectSpecialFilterMenuStatus(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onToggleSpecialFilterMenu: (value) => dispatch(toggleSpecialFilterMenu(value)),
    onSetSpecialFilterDataArray: (value) => dispatch(setSpecialFilterDataArray(value)),
    onSetSpecialFilterId: (value) => dispatch(setSpecialFilterId(value)),
    onSetFilterMenuStatus: (value) => dispatch(setFilterMenuStatus(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(SearchSpecial);
